import { render } from "./list-page.vue?vue&type=template&id=25a2dda4&scoped=true"
import script from "./list-page.vue?vue&type=script&lang=js"
export * from "./list-page.vue?vue&type=script&lang=js"

import "./list-page.vue?vue&type=style&index=0&id=25a2dda4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a2dda4"]])

export default __exports__